export const assistancesEn = [
  { id: '1', value: 'No' },
  { id: '13', value: 'No, but I need some assistance (Door-to-Door)' },
  { id: '4', value: 'Wheelchair (cannot transfer)' },
  { id: '15', value: 'Wheelchair (can transfer)' },
  { id: '3', value: 'Walker' },
  { id: '6', value: 'I need a gurney or stretcher' },
  { id: '9', value: 'Mileage Reimbursement' },
];
